import { render, staticRenderFns } from "./search-item.vue?vue&type=template&id=ee40bd20&scoped=true&"
import script from "./search-item.vue?vue&type=script&lang=js&"
export * from "./search-item.vue?vue&type=script&lang=js&"
import style0 from "./search-item.vue?vue&type=style&index=0&id=ee40bd20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee40bd20",
  null
  
)

export default component.exports